"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInputWrapper = exports.StyledCheckBoxWrapper = exports.StyledCheckBoxAndTextWrapper = exports.StyledRowButtonsWrapper = exports.StyledButtonsWrapper = exports.StyledOptionGroupsWrapper = exports.StyledAddNewLevelButtonWrapper = exports.StyledContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledContainer = styled_components_1.default.div `
  display: flex;
  position: relative;
  flex-direction: column;
  width: 296px;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  padding: ${({ theme }) => theme.Modal.Padding.XSmall}px
    ${({ theme }) => theme.Modal.Margin.XSmall}px
    ${({ theme }) => theme.Modal.Padding.Large}px
    ${({ theme }) => theme.Modal.Padding.Large}px;
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  border-radius: ${({ theme }) => theme.Border.Radius.Large}px;
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Modal};

  ${({ theme, variant }) => (variant === 'bullet-list' || !variant) &&
    `
    padding: ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
    width: fit-content;
    border: 1px solid ${theme.Color.Neutrals.Light};
    box-shadow: 0 0 8px -8px ${theme.Color.Overlay.Light};
  `}
`;
exports.StyledAddNewLevelButtonWrapper = styled_components_1.default.div `
  display: flex;
  margin-top: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`};
`;
exports.StyledOptionGroupsWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  max-height: ${({ theme }) => `${ui_common_components_1.utils.rem(240)}`};
  overflow: auto;

  ${({ theme }) => {
    return theme.Scrollbar.Default;
}}

  ::-webkit-scrollbar-track {
    margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)}`} 0;
  }

  ${({ theme, variant }) => (variant === 'bullet-list' || !variant) &&
    `
    padding: ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
    padding-right: ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  `}
}
`;
exports.StyledButtonsWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)}`};
  width: 256px;
  border-top: 1px solid ${({ theme }) => theme.Color.Neutrals.Light};
`;
exports.StyledRowButtonsWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  gap: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)}`};
`;
exports.StyledCheckBoxAndTextWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.StyledCheckBoxWrapper = styled_components_1.default.div `
  display: flex;
  margin-left: auto;
`;
exports.StyledInputWrapper = styled_components_1.default.div `
  width: 256px;
`;
//# sourceMappingURL=TextListOptionMenuOverview.style.js.map